import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import './LoaderComponent.scss'

const getFill = (customFill, light) => {
  if (customFill) {
    return customFill
  }

  return light ? '#FFF' : '#868686'
}

const LoaderComponent = ({ light, size, className, customFill }) => {
  const fill = getFill(customFill, light)
  const sizes = size === 'large' ? [50, 50] : [16, 16]

  return (
    <div
      className={classnames(`loader-component size-${size}`, className)}
      // Based on https://stackoverflow.com/a/38708396
      role="alert"
      aria-busy="true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width={`${sizes[0]}px`}
        height={`${sizes[1]}px`}
        fill={fill}
      >
        <path
          opacity=".25"
          d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
        />
        <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 16 16"
            to="360 16 16"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  )
}

LoaderComponent.propTypes = {
  light: PropTypes.bool,
  customFill: PropTypes.string,
  size: PropTypes.oneOf(['large', 'small']),
  className: PropTypes.string,
}

LoaderComponent.defaultProps = {
  light: false,
  size: 'large',
}

export default LoaderComponent
